// @flow
import { delay } from 'redux-saga';
import { call, put, take, takeLatest, fork, race } from 'redux-saga/effects';
import loginApi from 'api/auth/login';
import regenerateApi from 'api/auth/regenerate';
import { login, logout, regenerateToken, receiveAuth } from './authActions';
import Errors from 'lib/errors';
import { getSelected as getSelectedClientId } from 'containers/client/storage';
import TokenUtils from 'api/auth/TokenUtils';

const { getToken, setToken, clearToken } = TokenUtils;

function* loginSaga(action) {
  const {
    payload: { username, password },
  } = action;

  try {
    const { token, expiration, ...rest } = yield call(
      loginApi,
      username,
      password,
      getSelectedClientId()
    );
    yield call(setToken, token, expiration);
    yield call(delay, 500);
    yield put.resolve(
      receiveAuth({
        username,
        password,
        token,
        ...rest,
      })
    );
  } catch (error) {
    yield call(delay, 500);
    yield put(receiveAuth(error));
  }
}

function* regenerateDaemon() {
  let interval = 0.75 * 1800 * 1000;

  while (true) {
    const { action } = yield race({
      action: take(regenerateToken),
      interval: call(delay, interval), // 0.75 * expiration
    });

    const existingToken = yield call(getToken);
    const clientId =
      action && typeof action.payload === 'number'
        ? action.payload
        : getSelectedClientId();

    try {
      const { token, expiration, ...rest } = yield call(
        regenerateApi,
        existingToken,
        clientId
      );

      yield call(setToken, token, expiration);
      yield put.resolve(receiveAuth({ token, ...rest }));
      interval = Math.floor(0.75 * expiration * 1000);
    } catch (error) {
      // any regenerate error should forward to login page
      yield call(clearToken);
      yield put(receiveAuth(error));

      // then we block until we hve succssfully logged in
      yield take(login);
    }
  }
}

// only listen for errors when user is login
const match401Error = action => {
  if (action.error === true && Errors.isClientError(action.payload)) {
    if (action.payload.status === 401) {
      return true;
    }
  }

  return false;
};
function* listenForAuthenicationErrors() {
  while (true) {
    const { error } = yield take(receiveAuth);
    if (error === true) continue;

    const { error401 } = yield race({
      error401: take(match401Error),
      logout: take(logout),
    });

    if (error401) {
      yield put(logout());
    }
  }
}

export default function* authSaga(): Generator<*, *, *> {
  yield takeLatest(login, loginSaga);
  yield takeLatest(logout, clearToken);
  yield fork(listenForAuthenicationErrors);
  yield fork(regenerateDaemon);
}



// WEBPACK FOOTER //
// ./src/ducks/authSaga.js